module.exports = __webpack_public_path__ + "static/media/n03.bd6da396.jpg";